import api from "./api";

/**
 * Sadakat puanı uçları (backend: /api/loyalty). Yanıtlar ApiResponse zarfında
 * (res.data.data). Geçmiş uçları Spring Pageable döner.
 */
export const loyaltyService = {
  getSettings: () => api.get("/loyalty/settings"),
  updateSettings: (payload) => api.put("/loyalty/settings", payload),

  customerHistory: (customerId, params = {}) =>
    api.get(`/loyalty/customers/${customerId}/history`, { params }),
  adjust: (customerId, payload) =>
    api.post(`/loyalty/customers/${customerId}/adjust`, payload),
  redeem: (customerId, payload) =>
    api.post(`/loyalty/customers/${customerId}/redeem`, payload),

  salonHistory: (params = {}) => api.get("/loyalty/history", { params }),
};
